import React, { useRef } from 'react';
import { useMouseDrag } from '@yme/hooks/useMouseDrag';
import { MenuList } from './MenuList';
import { MenuContainerStyled, NavStyled } from './styled';
import { addOnClickHandler } from './utils';
export function Menu({ items: rawItems, labels, isRightToLeft }) {
    const navRef = useRef(null);
    const { mouseEventHandlers } = useMouseDrag(navRef);
    const items = addOnClickHandler(rawItems);
    return (React.createElement(MenuContainerStyled, { isRightToLeft: isRightToLeft },
        React.createElement(NavStyled, { ref: navRef, ...mouseEventHandlers },
            React.createElement(MenuList, { items: items, labels: labels, isRightToLeft: isRightToLeft }))));
}
